import React from "react";
import { Link } from "react-router-dom";
import styles from "./CaseStudy.module.css";
import { CASE_STUDY_HERO, CASE_STUDY_STATS } from "../assets";
import Lines from "../Lines";

export default function CaseStudy() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.inner}>
          <div className={styles.left}>
            <div className={styles.headings}>
              <p className={styles.kicker}>Case Study</p>
              <h2 className={styles.title}>
                Driving Efficiency at a Leading Railway Foundry
              </h2>
            </div>

            <Link to="/casestudy" className={styles.cta}>
              Read More
            </Link>

            <ul className={styles.stats}>
              {CASE_STUDY_STATS.map((stat) => (
                <li key={stat.id} className={styles.stat}>
                  <img
                    src={stat.icon}
                    alt=""
                    className={styles.statIcon}
                    width={40}
                    height={40}
                    loading="lazy"
                  />
                  {/* Wrapped so the mobile row can sit the text beside the
                      icon (Figma 12234:2068). */}
                  <div className={styles.statText}>
                    <p className={styles.statTitle}>{stat.title}</p>
                    <p className={styles.statBody}>
                      <Lines value={stat.body} />
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.right}>
            <img
              src={CASE_STUDY_HERO}
              alt="Rendering of a railway locomotive and freight rake"
              className={styles.hero}
              width={1249}
              height={639}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
